import { connect, ConnectedProps } from 'react-redux'

import { hideNavigation } from 'redux/actions'
import MobileMenu from 'components/layout/mobile-menu/index'
import { AppDispatch, RootState } from 'redux/store'

const mapDispatchToProps = (dispatch: AppDispatch): { hideNavigation: () => ReturnType<AppDispatch> } => ({
  hideNavigation: () => dispatch(hideNavigation())
})

const mapStateToProps = (state: RootState): { pageId: RootState['layout']['pageId'], flavour: RootState['layout']['flavour'], aol: RootState['aol']['name'], isDocDrafter: RootState['user']['isDocDrafter'], isLogged: RootState['user']['isLogged'], isLimitedAccess: RootState['user']['isLimitedAccess'], isExternalAuth: boolean, controller: RootState['layout']['controller'] } => ({
  pageId: state.layout.pageId,
  flavour: state.layout.flavour,
  aol: state.aol.name,
  isDocDrafter: state.user.isDocDrafter,
  isLogged: state.user.isLogged,
  isLimitedAccess: state.user.isLimitedAccess,
  isExternalAuth: state.user.details.isExternalAuth,
  controller: state.layout.controller
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export type MobileMenuContainerProps = ConnectedProps<typeof connector>

export default connector(MobileMenu)
